import { render, staticRenderFns } from "./BbsCategoryNumSetting.vue?vue&type=template&id=86f4ce00&scoped=true&"
import script from "./BbsCategoryNumSetting.vue?vue&type=script&lang=js&"
export * from "./BbsCategoryNumSetting.vue?vue&type=script&lang=js&"
import style0 from "./BbsCategoryNumSetting.vue?vue&type=style&index=0&id=86f4ce00&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86f4ce00",
  null
  
)

export default component.exports